import { useSuspenseQuery } from '@tanstack/react-query'

import {
  GetPropostaCompradoresDuplicarService,
  type TGetPropostaCompradoresDuplicarResponse,
} from '@/features/proposta/services/get-proposta-compradores-duplicar.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useSuspensePropostaCompradoresDuplicar = (numero: number) => {
  return useSuspenseQuery<TGetPropostaCompradoresDuplicarResponse>({
    queryKey: propostaKeys.compradoresDuplicar(numero),
    queryFn: () => new GetPropostaCompradoresDuplicarService().execute(numero).then((response) => response.data),
  })
}
